import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/lara-light-purple/theme.css';
import { ReportHeader } from '../../header/report-header';
import { DropoutSideBarFilter } from './side-bar-filter/dropout-side-bar-filter';
import { getDropoutStudentOperation } from './operations/get-dropout-student-operation';
import { ReportDropoutStudentType } from './side-bar-filter/report-dropout-student.type';

export interface DropoutStudent {
  branch: string;
  firstName: string;
  lastName: string;
  id: string;
  mobile: string;
  email: string;
  program: string;
  startYear: string;
  dropoutDate: string;
  annualSerialProgramNumber: number;
}

export const ReportDropoutStudents = () => {
  const [dropoutData, setDropoutData] = useState<DropoutStudent[]>([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (filters: ReportDropoutStudentType) => {
    const data = await getDropoutStudentOperation(
      filters,
      setDropoutData,
      setLoading,
    );
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <ReportHeader
        title="דו״ח תלמידים נושרים"
        description="דו״ח זה מציג מידע מקיף על תלמידים שעזבו את תכניות הלימוד. הדו״ח כולל פרטים אישיים, פרטי התכנית ומועד העזיבה."
        metadata={[
          { label: 'מטרת הדו״ח', value: 'מעקב אחר נשירת תלמידים' },
          { label: 'תדירות עדכון', value: 'יומי' },
        ]}
        category="education"
      />

      <div style={{ display: 'flex', gap: '20px' }}>
        <div
          style={{
            height: 'calc(100vh - 230px)',
            minHeight: '100%',
            width: '300px',
            minWidth: '250px',
          }}
        >
          <DropoutSideBarFilter onSearch={handleSearch} />
        </div>

        {/* Table Section */}
        <div style={{ flex: 1 }}>
          <DataTable
            value={dropoutData}
            rows={10}
            rowHover
            rowClassName={() => 'cursor-pointer'}
            rowsPerPageOptions={[5, 10, 25, 50]}
            emptyMessage={
              <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
            }
            dataKey="id"
            scrollable
            scrollHeight="calc(100vh - 300px)"
            loading={loading}
            tableStyle={{
              direction: 'rtl',
            }}
            className="dropout-students-table"
          >
            <Column
              field="branch"
              header="שלוחה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="firstName"
              header="שם פרטי"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="lastName"
              header="שם משפחה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="id"
              header="ת.ז"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="mobile"
              header="טלפון נייד"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="email"
              header="כתובת דוא״ל"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="program"
              header="תכנית לימודים"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />

            <Column
              field="annualSerialProgramNumber"
              header="מספר סידורי של תוכנית"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />

            <Column
              field="startYear"
              header="שנת התחלה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
            <Column
              field="dropoutDate"
              header="תאריך עזיבה"
              style={{ textAlign: 'right' }}
              headerStyle={{ textAlign: 'right' }}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};
